import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableInsuranceColumn = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableInsuranceColumn);
};
